export const CREATE_SESSION_REQUEST = "CREATE_SESSION_REQUEST";
export const CREATE_SESSION_SUCCESS = "CREATE_SESSION_SUCCESS";
export const CREATE_SESSION_FAILURE = "CREATE_SESSION_FAILURE";

export const GET_SESSIONS_REQUEST = "GET_SESSIONS_REQUEST";
export const GET_SESSIONS_SUCCESS = "GET_SESSIONS_SUCCESS";
export const GET_SESSIONS_FAILURE = "GET_SESSIONS_FAILURE";